import React from "react";
import TableButton from "./TableButton";
import { useTable } from "./Table";

const PageHelper = ({tableName}) => {
  const { onStartTutorial } = useTable();

  return (
    <TableButton onClick={onStartTutorial} className="order-1 border-[#D30039] text-customRed">
      Help
    </TableButton>
  );
};

export default PageHelper;
